export const localisation = {
	locale: '',
	currencyCode: '',
};
